<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <div v-if="!(options.lists['pharmacies-wholesalers'] || []).length">
            <div class="card shadow mb-3">
                <div class="card-body">
                    Bitte eine Liste vom Typ <b>Apotheken mit Großhandel</b> anlegen!
                </div>
            </div>
        </div>

        <div v-else>
            <timing-period-module :dto="config.timing" :options="options" :compare="false"></timing-period-module>

            <div class="card shadow mb-3">
                <div class="card-header py-3">
                    <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
                </div>
                <div class="card-body">

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['gh.ms.wholesaler']"></i>
                            Großhändler
                        </label>
                        <select class="form-control" v-model="config.wholesalerId">
                            <option :value="null">Bitte auswählen</option>
                            <option :value="wholesaler.id" v-for="wholesaler in options.wholesalers" v-if="wholesaler.short">
                                {{ wholesaler.short }}
                            </option>
                        </select>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col">
                    <filtering-module title="Liste"
                                      :pharmacies="false"
                                      :pzn-fill-empty="false"
                                      :dto="config.leftFiltering"
                                      :options="options"
                                      :show-other-filters="false"></filtering-module>
                </div>
                <div class="col">
                    <filtering-module title="Vergleichsliste"
                                      :pharmacies="false"
                                      :pzn-fill-empty="false"
                                      :dto="config.rightFiltering"
                                      :options="options"
                                      :show-other-filters="false"></filtering-module>
                </div>
            </div>
        </div>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../../Modules/TimingPeriodModule";
import FilteringModule from "../../Modules/FilteringModule";
import PharmacyFilterModule from "../../Modules/PharmacyFilterModule";

export default {
    components: {FilteringModule, TimingPeriodModule, PharmacyFilterModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto
        };
    },
    computed: {}
}
</script>
